import React from "react";
import { Container, Row, Col, Card, CardBody, CardDeck, CardFooter } from "reactstrap";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import { FormattedMessage, useIntl } from "react-intl";
import SeriesAccessorySearch from "../../components/AccessoryCreation/SeriesAccessorySearch";

function AccessoryCreation(props) {
  const intl = useIntl();

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="products.title" defaultMessage="What you want to create in BdP?" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <CardDeck>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <h3 className="card-title">
                        <FormattedMessage id="accessories.new_range.title" defaultMessage="New range of accessories" />
                      </h3>
                      <p className="card-text">
                        <FormattedMessage id="accessories.new_range.description" defaultMessage="Click the button below if you wish to create a new range of accessories" />
                      </p>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Link to="/accessories/accessory/new-range/-1/0/series" className="btn btn-outline-primary">
                    <FormattedMessage id="app.proceed" defaultMessage="Proceed" />
                  </Link>
                </CardFooter>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <h3 className="card-title">
                        <FormattedMessage id="accessories.existing_range.title" defaultMessage="Existing range" />
                      </h3>
                      <p className="card-text">
                        <FormattedMessage
                          id="accessories.existing_range.description"
                          defaultMessage="Click the button below if you would like to add some accessories to an existing range"
                        />
                      </p>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Link to="/accessories/accessory/new/-1/0/series" className="btn btn-outline-primary">
                    <FormattedMessage id="app.proceed" defaultMessage="Proceed" />
                  </Link>
                </CardFooter>
              </Card>
            </CardDeck>
          </Col>
        </Row>
        <Row>
          <Col>
            <h1 className="my-4">
              <FormattedMessage id="accessories.edit_view.title" defaultMessage="View / edit a accessory in BdP?" />
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h3 className="card-title">
                      <FormattedMessage id="accessories.open_accessory.title" defaultMessage="Edit an existing accessory" />
                    </h3>
                    <p className="card-text">
                      <FormattedMessage id="accessories.open_accessory.description" defaultMessage="If you would like to open an accessory, please use the options below." />
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-3">
                    <SeriesAccessorySearch
                      hideEmpties={true}
                      useGeneric={true}
                      accessorySelectText={intl.formatMessage({ id: "app.select", defaultMessage: "Select" })}
                      onAccessorySelect={(id) => props.history.push(`/accessories/accessory/${id.id}/${id.seriesId}/${id.version}/technical-information`)}
                    ></SeriesAccessorySearch>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AccessoryCreation;
